module.exports = __webpack_public_path__ + "static/media/anjana_event.027501ad.jpg";